var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStep2Active(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.9889,
    height: 39.9889,
    rx: 10,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9889 27.8905L11.7966 21.5252L13.0236 20.583L19.9889 25.9752L26.9541 20.583L28.1811 21.5252L19.9889 27.8905ZM19.9889 23.456L11.7966 17.0907L19.9889 10.7252L28.1811 17.0907L19.9889 23.456ZM19.9889 21.5407L25.7389 17.0907L19.9889 12.6407L14.2389 17.0907L19.9889 21.5407Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2Active);
export default __webpack_public_path__ + "static/media/Step2Active.4c1188d91adc6559260ce1982548a87e.svg";
export { ForwardRef as ReactComponent };